export const CLOSE = 'ACTIVATIONMODAL/CLOSE';

export const close = () => ({
  type: CLOSE,
});
